import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "icon"]

  connect() {
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    const isExpanded = this.contentTarget.classList.contains("hidden")

    if (isExpanded) {
      // Expand
      this.contentTarget.classList.remove("hidden")
      this.updateIcon(true)
    } else {
      // Collapse
      this.contentTarget.classList.add("hidden")
      this.updateIcon(false)
    }
  }

  updateIcon(isExpanded) {
    if (this.hasIconTarget) {
      const iconSvg = this.iconTarget.querySelector("svg")
      if (iconSvg) {
        const pathElement = iconSvg.querySelector("path")
        if (pathElement) {
          const chevronDownPath = "M6 9L12 15L18 9"
          const chevronUpPath = "M18 15L12 9L6 15"
          pathElement.setAttribute("d", isExpanded ? chevronUpPath : chevronDownPath)
        }
      }
    }
  }
}
